import { render, staticRenderFns } from "./UserSelector.vue?vue&type=template&id=11184c3e&scoped=true"
import script from "./UserSelector.vue?vue&type=script&lang=ts"
export * from "./UserSelector.vue?vue&type=script&lang=ts"
import style0 from "./UserSelector.vue?vue&type=style&index=0&id=11184c3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11184c3e",
  null
  
)

export default component.exports